module.exports = __webpack_public_path__ + "media/public/img/viator-round-color-01-75e0e71c4bf787f1c8912121e6bb0b85.svg";